
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/jocs",
      function () {
        return require("private-next-pages/3catinfo/jocs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/jocs"])
      });
    }
  